import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";

function AuthMatrixDetails({ fillAuthMatrixDetailsForm }) {
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState([]);

    const companyAuthMatrixFurtherDetails = useSelector((state) => state.companySlice?.companyAuthMatrixFurtherDetails);

    useEffect(() => {
        if (companyAuthMatrixFurtherDetails !== null || companyAuthMatrixFurtherDetails !== undefined) {
            setdata(companyAuthMatrixFurtherDetails);
            setloading(false);
        }
    }, [companyAuthMatrixFurtherDetails]);

    const onRowSelect = (event) => {
        fillAuthMatrixDetailsForm(event.data);
    };

    return (
        <div>
            <div className="p-datatable-sm">
                <DataTable selectionMode="single" dataKey="authMatrixDetailId" onRowSelect={onRowSelect} loading={loading} paginator rows={5} value={data} emptyMessage="No data found.">
                    <Column filter field="srNo" header="Sr No." />
                    <Column filter field="tblUser.userName" header="User Name" />
                    <Column filter field="lkpUserAuthLevel.userAuthLevelName" header="User Level" />
                </DataTable>
            </div>
        </div>
    );
}

export default AuthMatrixDetails;
